<template>
  <div id="app">
    <div id="header">
      <a href="https://happs.tv">
        <div id="backButton" alt="Back" class="toolbarItem">
          <div class="backgroundCircle clickable">
            <BackArrowIcon/>
          </div>
        </div>
      </a>
      <a href="https://happs.tv">
        <HappsLogo id="logo"/>
      </a>
      <div id="beta" class="inlineBlock">BETA</div>
      <h1 id="pageTitle" class="inlineBlock">FREQUENTLY ASKED QUESTIONS</h1>
    </div>
    <div id="container">

    </div>
    <VueFaqAccordion id="faq" :items="faqItems"/>
  </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'

import HappsLogo from '@/assets/svg/HappsLogo.vue'
import BackArrowIcon from '@/assets/svg/BackArrowIcon.vue'

const TAB_FAQ = 'FAQ'

export default {
  name: 'App',
  components: {
    VueFaqAccordion,
    HappsLogo,
    BackArrowIcon,
  },
  data() {
    const { happsAppOS } = this.$route.query

    return {
      faqItems: [
        {
          title: 'What is Happs?',
          value: `Happs is a live broadcasting platform that offers FREE world-class broadcasting tools, a community eager to collaborate, and a simple way for viewers to support creators financially. With Happs you can reach, engage and monetize your audience. Happs broadcasting tools allow you to muliticast to unlimited social platforms, invite unlimited guests, and enhance your broadcasts with graphics, b-roll, upper thirds, pop-up facts, and other on-screen elements. With Happs you can earn money from your viewers through ${happsAppOS === 'i' ? '' : 'sponsorships and '}financial awards.`,
          category: TAB_FAQ,
        },
        {
          title: 'How do I support broadcasters on Happs?',
          value: `${happsAppOS === 'i' ? '' : '<h2>Sponsorships</h2><br>Sponsorships are a great way to support a broadcaster on Happs. If a broadcaster has Sponsorships turned on you will find a button on their profile called "SPONSOR" that will allow you to pledge a monthly amount to financially support them directly.<br><br><b>Will I be charged immediately?</b><br><br>Yes. When supporting a broadcaster you will be charged immediately when you confirm your sponsorship, and then on approximately the same date of each month following. Your immediate payment unlocks badging and notifies the broadcaster of your support.<br><br>Note: Happs will not issue refunds behalf of broadcasters, except in extremely rare circumstances.<br><br>'}<h2>Awards</h2><br>In addition to sponsorship, all broadcasters are eligible to receive Awards.  Awards are a great way to support a broadcaster while watching their broadcasts. Awards can be sent using Coins which can be purchased or earned for being active on Happs.`,
          category: TAB_FAQ,
        },
        {
          title: 'How do I earn money on Happs?',
          value: `${happsAppOS === 'i' ? '' : '<h2>Sponsorships</h2><br>Sponsorships are open to any user on Happs who qualifies for a badge. There are three badges currently available: VIP, Student Journalist and Top Journalist. The requirements for each of those badges are listed below. To apply please email <a href="mailto:pdelahoya@happs.tv">pdelahoya@happs.tv</a>.<br><br>'}<h2>Awards</h2><br>Anyone on Happs is eligible to earn Awards! Viewers watching your broadcast on Happs can give awards that, if eligible, can be cashed in for real money. Awards can be sent using Coins which can be purchased or earned for being active on Happs. Coins used to send Awards have a typical value of 0.1 cent per Coin. In some special cases, like charity events, there may be different revenue sharing arrangements. For example, if a viewer sends 1,000 coins via an Award, the broadcaster would then receive $1 USD.`,
          category: TAB_FAQ,
        },
        {
          title: 'How do I cash out on Happs?',
          value: `<h3>Earnings & Payouts</h3><br>Our standard payout period is Net 30. If at anytime your account balance $200 or more, a payment request can be made and would be scheduled for 30 days after for the current account balance. For example, if a request for payment is made on April 30th that exceeds the minimum threshold of $200 USD, the payment would be made on or before May 30th. Payout processing time can vary, but typically takes around 3 – 5 business days. Weekends and public holidays can increase the amount of time that it takes for you to receive your payout. A record of all of your earnings and available balance can be found in your settings at: <a href="https://happs.tv/settings/earnings/earnings">https://happs.tv/settings/earnings/earnings</a>.<br><br><h3>Eligiblity</h3><br>If your balance is at least $200, you can request a payout from Happs. Happs users are not considered “payable” until all electronic or manual tax forms, explanations and additional documents (if required) have been submitted and approved.  If you qualify for payments, please send an email to payments@happs.tv.<br><br><h3>What are the fees for the payments?</h3><br>Happs does not charge any fees for payments.  However, our payment processor charges small fees (2.9% plus $0.30) on each transaction which will be deducted from your payout. These fees are disclosed in your settings and when you cash out.${happsAppOS === 'i' ? '' : '<br><br><h3>What is the Sponsorship Revenue share?</h3><br>Eligible broadcasters receive 70% of monthly recurring sponsorship revenue after applicable taxes and fees are deducted.<br><br>A summary of all transactions can be found on your settings.'}<br>`,
          category: TAB_FAQ,
        },
        {
        title: 'How do I get the VIP badge?',
        value: '<h2>Benefits</h2><br><li>VIP badge on your profile and next to your name in search</li><br><li>Eligibility to be featured on our Discover tab</li><br><li>Elevated access to collaborate with our team</li><br><h2>Minimum Requirements</h2><br><li>Average 500+ total viewers per broadcast*</li><br><li>Broadcast at least twice a week on average</li><br><li>At least four public broadcasts available</li><br><li>Content and behavior meets our Terms and Community Guidelines.</li><br><br>*min view count is reviewed quarterly and subject to possible change',
          category: TAB_FAQ,
        },
        {
        title: 'How do I get the Top Journalist badge?',
        value: '<h2>Benefits</h2><br><li>Top Journalist badge on your profile and next to your name in search</li><br><li>Eligibility to be featured on our Discover tab</li><br><li>Elevated access to collaborate with our team</li><br></li><h2>Minimum Requirements</h2><br>There are two ways to be considered for a Happs Top Journalist badge.<br><br><b>Broadcasters just joining the platform will be evaluated according to the following criteria via the application here:</b><br><br><li>Significant contributions to professional media outlet(s) for a period of at least 5 years.</li><br><li>Examples of work (written, photography, video, podcasts, etc.) that exemplify Happs best practices.</li><br><li>Awards and or public recognition for influential journalistic work.</li><br><li>Membership in professional journalism associations.</li><br><b>Broadcasters can also earn the Top Journalist badge via broadcasting excellence on Happs. In order to do so, members must:</b><br><br><li>Be an active member for at least 3 months.</li><br><li>Have demonstrated quality field broadcasts on compelling, note-worthy subject matter.</li><br><li>Have completed a minimum of 15 broadcasts.</li><br><li>Have at least 15,000 total views.</li><br><li>Demonstrated ability to engage with viewers.</li>',
          category: TAB_FAQ,
        },
        {
          title: 'Can I transfer my Periscope VIP badge to Happs?',
          value: '<h2>Periscope Badge Transfer Program</h2><br>In order to roll-over badges, you must:<br><ol><li>Send us an email from the same account you signed up for Happs with</li><li>Successfully link your Periscope account to your Happs account</li><li>Meet the guidelines below on Happs OR you can show you have met the following requirements at some point on Periscope within the last 3 months*:</li></ol><br><div style="padding-left: 50px">On your Happs account:<br><ul><li>Average 500+ total views (live and replay across all platforms) per broadcast**</li><li>Broadcast at least 2 times total before March 31st on Happs (15 minutes or longer)</li><li>Content and behavior meets Happs’ Terms of Service and Community Guidelines</li></ul><h4>OR</h4><br>On your Periscope account:<br><ul><li>Average 500+ total views (live and replay) per broadcast**</li><li>Broadcast at least twice a week on average</li><li>Have at least four public broadcasts available</li><li>Content and behavior meets Periscope’s Terms of Service</li></ul></div><br>*We reserve the right to make decisions on a case-by-case basis. Contact Peter Bittner at <a href="mailto:pbittner@happs.tv">pbittner@happs.tv</a> for more information.<br><br>**500 view minimum will be reviewed quarterly starting in 2021 and subject to possible change.',
          category: TAB_FAQ,
        },
        {
        title: 'Why can\'t I post text, images, or videos?',
        value: 'Happs\'s userbase has expanded extremely rapidly recently, which is outstanding! However, to be fully transparent, it\'s been hard for us to keep up with that growth. In an effort to keep our community safe and spam-free while we scale up our infrastructure and moderation capabilities, we\'ve disabled certain post types for new users. Users who earn a badge will still be able to post anything, and everyone will still be able to go live and schedule upcoming broadcasts. We greatly appreciate everyone\'s patience as we continue to improve our platform.',
          category: TAB_FAQ,
        },
      ],
    }
  },
}
</script>

<style scoped>
#header{
  overflow: hidden;
  position: fixed;
  padding: 0 30px;
  height: 62px;
  line-height: 62px;
  border-bottom: solid 2px var(--foreground2);
  top: 0;
  left: 0;
  right: 0;
  background-color: var(--header);
  z-index: 1000000;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
#header > * {
  vertical-align: middle;
  line-height: 64px;
}

#backButton {
  margin-left: 0px;
  margin-right: 20px;
}
#backButton .backgroundCircle {
  width: 30px;
  height: 30px;
  line-height: 30px;
  margin-top: 2px;
  border-radius: 15px;
  background-color: var(--background3);
  text-align: center;
  position: relative;
}
#backButton:hover .backgroundCircle{
  background-color: var(--background3Hover);
}
#backButton:hover:active .backgroundCircle{
  background-color: var(--background3Pressed);
}

#backButton svg {
  width: 22px;
  height: 22px;
  margin-bottom: 2px;
  vertical-align: middle;
}

#logo {
  width: 72px;
  height: auto;
  vertical-align: middle;
  margin-right: 6px;
}
#beta{
  background-color: var(--happsPink);
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 8px;
  line-height: normal;
  margin-top: 17px;
  margin-right: 10px;
}
#pageTitle {
  margin-left: 15px;
  font-size: 20px;
  animation-delay: 0.2s;
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
  animation-name: fadeIn, bottomIn;
}

#container {
  padding: 64px 0 0;
}
#faq {
  margin-top: 20px;
}
#faq >>> .faq-wrapper {
  max-width: unset;
}
#faq >>> .faq__nav {
  display: none;
  border: none;
  background: var(--background15);
}
#faq >>> .faq__nav-item {
  color: var(--white);
  font-size: 20px;
}

#faq >>> .accordion {
  border: none;
  background: var(--background1);
  overflow: hidden;
}
#faq >>> .accordion__title {
  background: var(--background2);
  padding: 20px 15px;
  box-shadow: 0 0 4px 1px #0004;
}
#faq >>> .accordion__title:hover, #faq >>> .accordion__title:active {
  background: var(--background25);
}
#faq >>> .accordion__title:hover:active {
  background: var(--background15);
}
#faq >>> .accordion__title p {
  font-size: 20px;
  color: var(--white);
}
#faq >>> .accordion__value {
  padding: 20px 15px;
}
#faq >>> .accordion__value div {
  font-size: 15px;
  color: var(--foreground25);
}
#faq >>> .accordion__toggle-button {
  background: none;
}
#faq >>> .accordion__toggle-button::before, #faq >>> .accordion__toggle-button::after {
  background: var(--happsPink);
}
</style>
